module.exports = __webpack_public_path__ + "img/mclogi-desktop.927b686.png";